import '../../css/Login.css';

import LoginForm from '../../components/forms/LoginForm';
import haleonLogo from '../../images/Haleon/HaleonLogo.svg';
import img1 from '../../images/Haleon/happyFamily.png';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const LoginPage = ({ t }) => {
	const navigate = useNavigate();

	useEffect(() => navigate('/welcome' + window.location.search), []);

	return (
		<div className="text-center">
			<div className="logo-position">
				<img src={haleonLogo} alt="haleon" style={{ width: '30%' }} />
			</div>
			<img src={img1} alt="pic" className="w-100" />
			<div className="layout-position">
				<div className="login-card" style={{ textAlign: 'center' }}>
					<br />

					<h1 className="mt-2 font-family-hero-new">{t('Log In')}</h1>
					<div className="mt-1"></div>
					<hr className="green-line" />
					<p className="mt-2 text-center font-weight-400">
						{t('To log in, please enter your phone number')}:
					</p>
					<LoginForm
						formConfig={{
							label: 'Phone Number',
							placeholder: 'Enter Your Phone Number',
							layout: 'vertical',
							btnText: 'Log In / Sign Up',
						}}
					/>
				</div>
				{/* <Modal
                open={false}
                centered
                footer={null}
                className="login-age-modal"
                closable={false} >
               <div className="login-error-img-container">
             <img src={errorImg} alt="" style={{ width: '20vw' }}></img>
                </div>
                 <br />
               <div style={{ fontWeight: 'bold', fontSize: '20px' }}>
                    Invalid QR Code, please rescan a validate QR again
                </div>
             </Modal> */}
			</div>
		</div>
	);
};

export default LoginPage;
